import { useContext, useState } from "react";
import { useFinacialDetailsService } from "../../api/apiEndpoints/FinancialDetails";
import { useLocalStorage } from "../../logic/LocalStorage/LocalStorage";
import { FinancialDetailsContext } from "../context/FinancialDetails";
import { String } from "../../constants/Strings";

const useFinancialDetails = () => {
  const { saveFinacialDetail } = useFinacialDetailsService();
  const [monthlySalary, setmonthlySalary] = useState("");
  const [monthlySaving, setmonthlySaving] = useState("");
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarmessage, setSnackbarMessage] = useState({});
  const { saveLocalFinancialData } = useLocalStorage();
  const { financialDetailCollectData } = useContext(FinancialDetailsContext);
  const saveFinancialData = async (userId, activeButton) => {
    const data = {
      userId: `${userId}`,
      monthlySalary: monthlySalary,
      investmentStyle: activeButton,
      monthlySaving: monthlySaving,
    };
    if (!monthlySalary || !monthlySaving || !activeButton) {
      setSnackbarOpen(true);
      setSnackbarMessage({
        message: String.ChildPlannig.pleaseAllFeilds,
        severity: String.ErrorSeverity,
      });
      return;
    }
    try {
      saveLocalFinancialData(`financialData-${userId}`, data);
      financialDetailCollectData({
        monthlySaving: monthlySaving,
        monthlyIncome: monthlySalary,
      });
      const response = await saveFinacialDetail({ data });

      if (response.httpCode === 200) {
        setSnackbarOpen(true);
        setSnackbarMessage({
          message: String.Monthlyincome.successMessage,
          severity: String.successSeverity,
        });
        return true;
      } else {
        setSnackbarOpen(true);
        setSnackbarMessage({
          message: String.Monthlyincome.ERROR_MESSAGES.errorWhileSaving,
          severity: String.ErrorSeverity,
        });
      }
    } catch (error) {
      setSnackbarOpen(true);
      setSnackbarMessage({
        message: String.Monthlyincome.ERROR_MESSAGES.errorWhileSaving,
        severity: String.ErrorSeverity,
      });
    }
    return false;
  };
  return {
    saveFinancialData,
    monthlySalary,
    monthlySaving,
    snackbarOpen,
    snackbarmessage,
    setmonthlySalary,
    setmonthlySaving,
    setSnackbarOpen,
  };
};

export default useFinancialDetails;
